module.exports = __webpack_public_path__ + "static/media/echeck1.bb56b838.png";